import { SUPPORTED_LOCALES } from './constants.helper';

const DEFAULT_LANGUAGE = 'en';
const I18N_STORAGE_KEY = 'i18nextLng';
const RTL_LANGUAGES = new Set(['ar', 'he']);

const LANGUAGE_MAPPINGS = {
  'zh-tw': 'zh-Hant',
  'zh-cn': 'zh-Hans',
};

const getNormalizedLocale = (locale) => {
  if (!locale || typeof locale !== 'string') {
    return DEFAULT_LANGUAGE;
  }

  const normalizedLocale = locale.toLowerCase();

  if (LANGUAGE_MAPPINGS[normalizedLocale]) {
    return LANGUAGE_MAPPINGS[normalizedLocale];
  }

  if (SUPPORTED_LOCALES.includes(normalizedLocale)) {
    return normalizedLocale;
  }

  const shortLocale = normalizedLocale.substring(0, 2);

  return SUPPORTED_LOCALES.includes(shortLocale)
    ? shortLocale
    : DEFAULT_LANGUAGE;
};

/**
 * Sets the closest supported language based on the browser locale.
 *
 * @param {object} i18n - i18n instance with a changeLanguage method.
 */
export const setLanguageCode = (i18n) => {
  const browserLanguage = window?.navigator?.language;
  const languageToSet = getNormalizedLocale(browserLanguage);

  localStorage.setItem(I18N_STORAGE_KEY, languageToSet);
  i18n.changeLanguage(languageToSet);
};

/**
 * Returns whether a language is right-to-left.
 *
 * @param {string} languageCode - Language code such as `ar`, `he-IL`, or `en`.
 * @returns {boolean}
 */
export const isRightToLeft = (languageCode) => {
  const selectedLanguageCode =
    languageCode ?? localStorage.getItem(I18N_STORAGE_KEY);

  const normalizedLanguage = getNormalizedLocale(selectedLanguageCode);

  return RTL_LANGUAGES.has(normalizedLanguage);
};
